import React from "react";
import AppLayout from "./layout";


export default function App() {
    return (
        <AppLayout />
    )
}